"use strict";

var _taggedTemplateLiteral = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var remove_svg_1 = __importDefault(require("./assets/remove.svg"));

var TypeaheadResultContainer = styled_components_1.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 16px;\n  text-align: left;\n  padding: 8px 12px;\n  /* border-top: 1px solid rgba(187, 70, 70, 0.1); */\n  background-color: rgba(0, 50, 100, 0);\n  transition: 150ms ease;\n\n  ", "\n\n  &:hover {\n    background-color: rgba(0, 50, 100, 0.08);\n    ", "\n  }\n"])), function (_ref) {
  var selected = _ref.selected;
  return selected && "\n      font-weight: 800;\n      ";
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected && "\n      background-color: rgba(100, 0, 50, 0.08); \n      ";
});

var TypeaheadResult = function TypeaheadResult(_ref3) {
  var label = _ref3.item.label,
      selected = _ref3.selected;
  return react_1.default.createElement(TypeaheadResultContainer, {
    selected: selected
  }, label, selected && react_1.default.createElement("img", {
    src: remove_svg_1.default,
    style: {
      flexShrink: 0
    },
    alt: "Remove item"
  }));
};

exports.default = TypeaheadResult;